export default __webpack_public_path__ + "static/media/Corporate_3.f7990356.png";